/**
 * StoreDetailContainer
 * --
 */
import React from 'react';
import StoreDetailPresenter from './StoreDetailPresenter';

const StoreDetailContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <StoreDetailPresenter />
    </>
  );
};

export default StoreDetailContainer;
